exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".st0--2k4BIxe6{fill:none;stroke:#fff;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.st1--2FT6fZdj{fill:#f7f7f7;stroke:#fff;stroke-width:2;stroke-miterlimit:10}.st2--2t3osKFy{fill:#fff}.st3--2EYO1FO_{fill:#3faed5;stroke:#fff;stroke-width:2;stroke-miterlimit:10}.st4--1NgsKF-z{fill:#e8eaea}.st5--1neJM8qx{fill:#f8b99f}.st6--1G9vg92F{fill:#e8e7e7}.st7--2njJ99b4{fill:#f2f0ef}.st8--3KPnC7qn{opacity:.4}.st9--3b4Sj5RE{fill:#fac8b2}.st10--_1vRlVwE{fill:#602d11}.st11--1oxNrRLF{fill:#eeedec}.st12--2AV7hlUH{fill:#421b0d}.st13--1jvz1wh2{fill:#4a1d0e}.st14--1tvF5gEd{fill:#582610}.st15--2PxYmSa6{opacity:.68}.st16--2rWvRnk4{fill:#cf2a27}.st17--1pgqjo-1{fill:#f1f2f5}.st18--1bPhVZ96{fill:#e5e5e4}.st19--2KlJZPFj{fill:#99ca2f}.st20--3ePjtM0S{font-family:Orbitron,sans-serif;font-weight:700}.st21--3bccgXEw{font-size:11.3123px}.st22--2wYFY8UA{fill:#5a6366}.st23--xewzLrZ1{font-size:6.9029px}", ""]);

// exports
exports.locals = {
	"st0": "st0--2k4BIxe6",
	"st1": "st1--2FT6fZdj",
	"st2": "st2--2t3osKFy",
	"st3": "st3--2EYO1FO_",
	"st4": "st4--1NgsKF-z",
	"st5": "st5--1neJM8qx",
	"st6": "st6--1G9vg92F",
	"st7": "st7--2njJ99b4",
	"st8": "st8--3KPnC7qn",
	"st9": "st9--3b4Sj5RE",
	"st10": "st10--_1vRlVwE",
	"st11": "st11--1oxNrRLF",
	"st12": "st12--2AV7hlUH",
	"st13": "st13--1jvz1wh2",
	"st14": "st14--1tvF5gEd",
	"st15": "st15--2PxYmSa6",
	"st16": "st16--2rWvRnk4",
	"st17": "st17--1pgqjo-1",
	"st18": "st18--1bPhVZ96",
	"st19": "st19--2KlJZPFj",
	"st20": "st20--3ePjtM0S",
	"st21": "st21--3bccgXEw",
	"st22": "st22--2wYFY8UA",
	"st23": "st23--xewzLrZ1"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[local]--[hash:base64:8]!./~/sass-loader!./src/components/shared/laptop/styles.scss
// module id = 1028
// module chunks = 0